import { AutogenModelDetentionHist, AutogenRowDetentionHist } from "./autogen/AutogenModelDetentionHist";

export class ModelDetentionHist extends AutogenModelDetentionHist<RowDetentionHist> {
	constructor() {
		super(RowDetentionHist);
	}
}

export class RowDetentionHist extends AutogenRowDetentionHist {
}